import { render } from "./yc-qxc.vue?vue&type=template&id=6c5f44cd&scoped=true"
import script from "./yc-qxc.vue?vue&type=script&lang=js"
export * from "./yc-qxc.vue?vue&type=script&lang=js"

import "./yc-qxc.vue?vue&type=style&index=0&id=6c5f44cd&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5f44cd"]])

export default __exports__